import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { ToastModule } from 'primeng/toast';
import { DropdownModule } from 'primeng/dropdown';
import { MessageService } from 'primeng/api';
import { NGXLogger } from 'ngx-logger';
import { InterventiService } from '../../../services/interventi.service';
import { FirebaseStorageService } from '../../../services/firebase-storage.service';
import { Rendicontazione } from '../../../models/rendicontazione.model';
import { TipoRendicontazione } from '../../../models/tipo-rendicontazione.model';
import { Intervento } from '../../../models/intervento.model';

@Component({
  selector: 'app-modifica-rendicontazione',
  templateUrl: './modifica-rendicontazione.component.html',
  styleUrls: ['./modifica-rendicontazione.component.css'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    DialogModule,
    ButtonModule,
    InputNumberModule,
    InputTextareaModule,
    ToastModule,
    DropdownModule
  ],
  providers: [MessageService]
})
export class ModificaRendicontazioneComponent implements OnInit {
  @Input() visible: boolean = false;
  @Output() visibleChange = new EventEmitter<boolean>();
  @Input() rendicontazione: Rendicontazione | null = null;
  @Input() intervento: Intervento | null = null;
  @Output() rendicontazioneModificata = new EventEmitter<Rendicontazione>();

  importoRendicontato: number = 0;
  importoFinanziato: number = 0;

  tipoRendicontazione: any = null;
  note: string = '';
  tipiRendicontazione: any[] = [
    { id: 1, value: 'ACCONTO', label: 'Acconto 50%', descrizione: 'Rendicontazione a titolo di acconto' },
    { id: 2, value: 'SALDO', label: 'Saldo', descrizione: 'Rendicontazione a titolo di saldo' }
  ];

  modificaInCorso: boolean = false;

  constructor(
    private messageService: MessageService,
    private logger: NGXLogger,
    private firebaseStorageService: FirebaseStorageService,
    private interventiService: InterventiService
  ) {}

  ngOnInit() {}

  show(rendicontazione: Rendicontazione, intervento: Intervento) {
    this.logger.info('[MODIFICA RENDICONTAZIONE] Mostra modifica rendicontazione', rendicontazione);
    this.rendicontazione = rendicontazione;
    this.intervento = intervento;

    // Popola i campi con i valori esistenti
    this.importoRendicontato = rendicontazione.importo;
    this.importoFinanziato = intervento?.importoFinanziato ?? 0;

    // Trova il tipo di rendicontazione corrispondente (sempre disabilitato)
    this.tipoRendicontazione = this.tipiRendicontazione.find(t => t.value === rendicontazione.tipo.descrizione) || null;

    this.note = rendicontazione.note || '';

        this.visible = true;
    this.visibleChange.emit(this.visible);
  }

  hide() {
    this.visible = false;
    this.visibleChange.emit(this.visible);
    this.resetForm();
  }

  private resetForm() {
    this.tipoRendicontazione = null;
    this.importoRendicontato = 0;
    this.note = '';
    this.modificaInCorso = false;
  }

  onTipoRendicontazioneChange(event: any) {
    this.logger.info('[MODIFICA RENDICONTAZIONE] Tipo rendicontazione cambiato', event.value);
  }

  isFormValid(): boolean {
    return this.importoRendicontato > 0 &&
           this.importoRendicontato <= this.importoFinanziato;
  }



  salvaModifiche() {
    if (!this.rendicontazione || !this.intervento) return;

    this.modificaInCorso = true;
    this.logger.info('[MODIFICA RENDICONTAZIONE] Salvataggio modifiche per rendicontazione', this.rendicontazione.id);

    const rendicontazioneModificata: Rendicontazione = {
      ...this.rendicontazione,
      importo: this.importoRendicontato,
      // Il tipo rimane invariato (non modificabile)
      note: this.note
    };

    this.interventiService.modificaRendicontazione(
      this.intervento.id!,
      this.rendicontazione.id,
      rendicontazioneModificata
    ).subscribe({
      next: (rendicontazioneAggiornata: Rendicontazione) => {
        this.logger.info('[MODIFICA RENDICONTAZIONE] Rendicontazione modificata con successo:', rendicontazioneAggiornata);
        this.messageService.add({
          severity: 'success',
          summary: 'Modifica rendicontazione',
          detail: 'La rendicontazione è stata modificata con successo',
          life: 5000
        });
        this.rendicontazioneModificata.emit(rendicontazioneAggiornata);
        this.hide();
      },
      error: (error: any) => {
        this.logger.error('[MODIFICA RENDICONTAZIONE] Errore durante la modifica della rendicontazione:', error);
        this.messageService.add({
          severity: 'error',
          summary: 'Errore',
          detail: 'Si è verificato un errore durante il salvataggio delle modifiche'
        });
      },
      complete: () => {
        this.modificaInCorso = false;
      }
    });
  }
}
